// ── Email helper — calls /api/send-email serverless function ─────────────────
// All emails sent from info@mp.care (Resend verified domain)

const API_URL = '/api/send-email';

export async function sendEmail(type, data, to) {
  try {
    const res = await fetch(API_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ type, data, to }),
    });
    const json = await res.json();
    if (!res.ok) {
      console.error('Email API error:', json.error);
      return { success: false, error: json.error };
    }
    // api/send-email.js ALWAYS answers with a pdfAttached field (false for every email that has no PDF), so only an
    // INVOICE email may report it: for any other type it is meaningless, and a future caller that read false as
    // "the PDF failed" would misfire. Every other email keeps the exact { success, id } shape it always had.
    if (type === 'invoice' && typeof json.pdfAttached === 'boolean') return { success: true, id: json.id, pdfAttached: json.pdfAttached };
    return { success: true, id: json.id };
  } catch (err) {
    console.error('Email send failed:', err);
    return { success: false, error: err.message };
  }
}

// ── Convenience wrappers ────────────────────────────────────────────────────

// Admin notifications
export const emailSignup         = (data) => sendEmail('signup', data);          // New account application → admin
export const emailMaterialOrder  = (data) => sendEmail('material_order', data);  // Material order → admin

// Customer-facing
export const emailWelcome        = (data) => sendEmail('welcome', data);         // Account approved → customer
export const emailOrderCompleted = (data) => sendEmail('order_completed', data); // Order confirmed → customer
export const emailOrderShipped   = (data) => sendEmail('order_shipped', data);   // Order shipped → customer
export const emailInvoice        = (data) => sendEmail('invoice', data);         // Invoice → customer
export const emailToolRecall     = (data) => sendEmail('tool_recall', data);     // Tool recall → shop

// Order notifications (admin + rep)
export const emailOrderPlaced    = (data) => sendEmail('order_placed', data);    // New order → admin
export const emailRepOrderNotify = (data) => sendEmail('rep_order_notify', data);// New order → assigned rep

// Rep assignment
export const emailRepAssigned    = (data) => sendEmail('rep_assigned', data);    // Rep assigned → rep email
export const emailRepChanged     = (data) => sendEmail('rep_changed', data);     // Rep changed → admin

// Payment lifecycle
export const emailPaymentReminder = (data) => sendEmail('payment_reminder', data); // Due-tomorrow reminder → customer
export const emailPaymentOverdue  = (data) => sendEmail('payment_overdue', data);  // Past-due alert → admin
export const emailOrderCancelled  = (data) => sendEmail('order_cancelled', data);  // Order cancelled → customer

// Rep invoice change requests -> admin (fire-and-forget; caller logs failures)
export const emailInvoiceAdjustRequest = (data) => sendEmail('invoice_adjust_request', data); // Adjustment request -> admin
export const emailInvoiceVoidRequest   = (data) => sendEmail('invoice_void_request', data);   // Void request -> admin

// Admin changed / voided a rep's invoice from the Commission tab -> the rep (fire-and-forget; caller logs failures)
export const emailRepInvoiceChanged = (data) => sendEmail('rep_invoice_changed', data, data && data.repEmail);

// Marketing
export const emailBroadcast     = (data, to) => sendEmail('broadcast', data, to);

// Training — new video added, sent to whichever audience(s) it's visible to
export const emailNewTrainingVideo = (data, to) => sendEmail('new_training_video', data, to);
